import { moduleFactory } from "@/store/resource";

const resourceModule = moduleFactory("transaction");

resourceModule.getters.totalRevenueOnDate = state => date => {
  let totalRevenueOnDate = state.transactions
    .filter(transaction => {
      let transactionDate = new Date(Date.parse(transaction.paid_at));

      return (
        transaction.state === 0 &&
        date.getDate() === transactionDate.getDate() &&
        date.getMonth() === transactionDate.getMonth() &&
        date.getFullYear() === transactionDate.getFullYear()
      );
    })
    .reduce((a, b) => {
      return a + Number(b.price);
    }, 0);

  return Number(totalRevenueOnDate.toFixed(2));
};

resourceModule.getters.totalRevenueOnMonth = state => date => {
  let totalRevenueOnMonth = state.transactions
    .filter(transaction => {
      let transactionDate = new Date(Date.parse(transaction.paid_at));

      return (
        transaction.state === 0 &&
        date.getMonth() === transactionDate.getMonth() &&
        date.getFullYear() === transactionDate.getFullYear()
      );
    })
    .reduce((a, b) => {
      return a + Number(b.price);
    }, 0);

  return Number(totalRevenueOnMonth.toFixed(2));
};

resourceModule.state.dictionary = {
  register: "Starteinheiten",
  paypal: "PayPal",
  stripe: "Kreditkarte (Stripe)",
  prepaid: "Vorkasse",
  "friend-request": "Freundschaftsanfrage",
  message: "Nachricht",
  "gif-message": "GIF-Nachricht",
  "gift-message": "Geschenk",
  "blink-message": Laravel.settings.blinkName,
  "image-message": "Bildnachricht",
  coupon: "Gutscheincode",
  "admin-allowance": "Admin-Gutschrift",
  call2pay: "Call2Pay",
  paysafecard: "Paysafecard",
  handypay: "HandyPay",
  sofort: "Sofortüberweisung",
  manual: "Manueller Eintrag",
  "micropayment-credit-card": "Kreditkarte (Micropayment)",
  miscellaneous: "sonstige"
};

resourceModule.getters.dictionaryEntry = state => key => {
  if (key === "blink-message") {
    return Laravel.settings.blinkName;
  }

  return state.dictionary[key] === undefined
    ? "unbekannt"
    : state.dictionary[key];
};

resourceModule.getters.transaction = state => id => {
  return state.transactions.filter(transaction => transaction.id == id);
};

export const transactionModule = resourceModule;
